'use client'

import { createContext, useContext } from 'react'

export type LocaleContextValue = {
  circularProgress: {
    loading: string
  }
  dialog: {
    close: string
  }
  select: {
    close: string
  }
}

export const LocaleContext = createContext<LocaleContextValue | null>(null)

export const useLocaleContext = (): LocaleContextValue => {
  const localeContext = useContext(LocaleContext)

  if (localeContext === null) {
    throw new Error('useLocaleContext must be used within a LocaleProvider')
  }

  return localeContext
}
